import React from "react";

import ButtonGroup from "@material-ui/core/ButtonGroup";
import PropTypes from "prop-types";

import useStyles from "./RbButtonGroup.styles";

export const RbButtonGroup = React.forwardRef(function RbButtonGroup(
  props,
  ref
) {
  const { align, gap, ...other } = props;

  const classes = useStyles(props);

  return <ButtonGroup {...other} ref={ref} classes={classes} />;
});

RbButtonGroup.propTypes = {
  /** Align button horizontally. */
  align: PropTypes.oneOf(["flex-start", "center", "flex-end"]),
  /** Define a gap between buttons. */
  gap: PropTypes.number,
};

RbButtonGroup.defaultProps = {
  align: "flex-start",
  gap: undefined,
};

export default React.memo(RbButtonGroup);
